export const helpers = {
  extractPhoneNumbersFromCSV: (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        try {
          const text = event.target.result;
          const lines = text.split('\n').filter(line => line.trim());

          if (lines.length === 0) {
            reject(new Error('CSV file is empty'));
            return;
          }

          const header = lines[0].toLowerCase().split(',').map(h => h.trim());
          const phoneColumnIndex = header.findIndex(h =>
            h === 'phone number' || h === 'phonenumber' || h === 'phone'
          );

          if (phoneColumnIndex === -1) {
            reject(new Error('CSV must contain "phone number" column'));
            return;
          }

          const phoneNumbers = [];
          for (let i = 1; i < lines.length; i++) {
            if (lines[i].trim()) {
              const columns = lines[i].split(',').map(col => col.trim());
              const phone = columns[phoneColumnIndex];
              if (phone) {
                const cleanPhone = phone.replace(/\D/g, '');
                if (cleanPhone) {
                  phoneNumbers.push(cleanPhone);
                }
              }
            }
          }

          if (phoneNumbers.length === 0) {
            reject(new Error('No valid phone numbers found in CSV'));
            return;
          }

          resolve(phoneNumbers);
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = () => {
        reject(new Error('Error reading CSV file'));
      };

      reader.readAsText(file);
    });
  },

  hasPermission: (adminData, permission) => {
    if (!adminData) return false;

    const role = (adminData.role || '').toLowerCase();
    if (role === 'super_admin') return true;
    if (
      role === 'seo_admin'
      && (permission === 'view_seo' || permission === 'edit_seo')
    ) {
      return true;
    }

    const access = adminData.access;
    if (Array.isArray(access)) {
      if (access.includes('all')) return true;
      if (
        access.includes('seo_tab')
        && (permission === 'view_seo' || permission === 'edit_seo')
      ) {
        return true;
      }
      if (
        access.includes('spin_wheel_tab')
        && (permission === 'view_spin_wheel' || permission === 'manage_spin_wheel')
      ) {
        return true;
      }
    }

    const permissions = adminData.permissions;
    if (!permissions || !Array.isArray(permissions)) return false;

    if (permissions.includes('all')) return true;
    if (permissions.includes(permission)) return true;
    if (permission === 'view_spin_wheel' && permissions.includes('view_settings')) return true;
    if (permission === 'manage_spin_wheel' && permissions.includes('manage_settings')) return true;
    return false;
  },

  hasSeoAccess: (adminData) => helpers.hasPermission(adminData, 'view_seo'),

  hasSeoEditAccess: (adminData) => helpers.hasPermission(adminData, 'edit_seo'),

  hasSpinWheelAccess: (adminData) => helpers.hasPermission(adminData, 'view_spin_wheel'),

  hasSpinWheelEditAccess: (adminData) => helpers.hasPermission(adminData, 'manage_spin_wheel'),

  formatQatarTime: (dateStr) => {
    if (!dateStr) return '-';
    try {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Qatar',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });

      const parts = formatter.formatToParts(new Date(dateStr));
      const p = {};
      parts.forEach(({ type, value }) => p[type] = value);

      return `${p.day}-${p.month}-${p.year} ${p.hour}:${p.minute}\u00A0${p.dayPeriod.toUpperCase()}`;
    } catch (e) {
      return new Date(dateStr).toLocaleString();
    }
  },

  getRelativeTime: (date) => {
    if (!date) return 'N/A';
    const now = Date.now();
    const diff = now - new Date(date).getTime();
    if (diff < 0) return 'now';

    const seconds = Math.floor(diff / 1000);
    if (seconds < 60) return `${seconds} secs`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} min${minutes !== 1 ? 's' : ''}`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hr${hours !== 1 ? 's' : ''}`;
    const days = Math.floor(hours / 24);
    return `${days} day${days !== 1 ? 's' : ''}`;
  }

}
